// Copyright (c) Move Closer 2022.

import { BenefitProgram } from '../../contracts/programs'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const supportedBenefitPrograms: BenefitProgram[] = [
  BenefitProgram.FriendsAndFamily,
  BenefitProgram.Kameleon,
  BenefitProgram.MilesAndMore
]
